module.exports = __webpack_public_path__ + "img/ccl_gallery2.e57a5b13.jpg";